import React from "react";

const Pagination = ({
  ticketsPerPage,
  totalTickets,
  paginate,
  currentPage,
}) => {
  const pageNumbers = [];
  const totalPages = Math.ceil(totalTickets / ticketsPerPage);
  const maxPagesToShow = 5; // Max number of page links to show at a time
  const halfMaxPagesToShow = Math.floor(maxPagesToShow / 2);

  let startPage = Math.max(currentPage - halfMaxPagesToShow, 1);
  let endPage = Math.min(currentPage + halfMaxPagesToShow, totalPages);

  if (endPage - startPage < maxPagesToShow - 1) {
    if (currentPage <= halfMaxPagesToShow) {
      endPage = Math.min(maxPagesToShow, totalPages);
    } else if (currentPage + halfMaxPagesToShow >= totalPages) {
      startPage = Math.max(totalPages - maxPagesToShow + 1, 1);
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  return (
    <nav>
      <ul className="pagination">
        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <a
            onClick={() => currentPage > 1 && paginate(currentPage - 1)}
            // href="#"
            className="page-link"
            style={{ cursor: "pointer" }}
          >
            Trang trước
          </a>
        </li>
        {startPage > 1 && (
          <>
            <li className="page-item">
              <a
                onClick={() => paginate(1)}
                // href="#"
                className="page-link"
                style={{ cursor: "pointer" }}
              >
                1
              </a>
            </li>
            {startPage > 2 && (
              <li className="page-item disabled">
                <span className="page-link">...</span>
              </li>
            )}
          </>
        )}
        {pageNumbers.map((number) => (
          <li
            key={number}
            className={`page-item ${currentPage === number ? "active" : ""}`}
          >
            <a
              onClick={() => paginate(number)}
              // href="#"
              className="page-link"
              style={{ cursor: "pointer" }}
            >
              {number}
            </a>
          </li>
        ))}
        {endPage < totalPages && (
          <>
            {endPage < totalPages - 1 && (
              <li className="page-item disabled">
                <a className="page-link">...</a>
              </li>
            )}
            <li className="page-item">
              <a
                onClick={() => paginate(totalPages)}
                // href="#"
                className="page-link"
              >
                {totalPages}
              </a>
            </li>
          </>
        )}
        <li
          className={`page-item ${
            currentPage === totalPages ? "disabled" : ""
          }`}
        >
          <a
            onClick={() =>
              currentPage < totalPages && paginate(currentPage + 1)
            }
            // href="#"
            className="page-link"
            style={{ cursor: "pointer" }}
          >
            Trang sau
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
